"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const noop_1 = __importDefault(require("lodash/noop"));
const DataTableHeader_styled_1 = require("./DataTableHeader.styled");
const Icon_1 = require("../Icon");
const isString_1 = __importDefault(require("lodash/isString"));
const DataTable_styled_1 = require("../DataTable/DataTable.styled");
const useViewMore_1 = __importDefault(require("../DataTable/useViewMore"));
const ContextMenu_1 = __importDefault(require("../ContextMenu/ContextMenu"));
const useWindowSize_1 = __importDefault(require("../useWindowSize"));
const isIcon = (icon) => {
    return typeof icon === "function";
};
const DataTableHeader = ({ icon, actions, title }) => {
    const LeftIcon = icon && (isIcon(icon) ? icon : icon.left);
    const RightIcon = icon && !isIcon(icon) && icon.right;
    const $title = React.useRef(null);
    const $ghostTitle = React.useRef(null);
    const [isTitleOverflowing, setIsTitleOverflowing] = React.useState(false);
    const { open, close, viewMorePopup } = useViewMore_1.default();
    const { width } = useWindowSize_1.default();
    React.useLayoutEffect(() => {
        const currentTitle = $title.current;
        const ghostTitle = $ghostTitle.current;
        if (!currentTitle) {
            return;
        }
        if (!ghostTitle) {
            return;
        }
        setIsTitleOverflowing(isString_1.default(title) && currentTitle.getBoundingClientRect().width < ghostTitle.getBoundingClientRect().width);
    }, [width]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DataTableHeader_styled_1.Container, { hasIcon: Boolean(LeftIcon) },
            LeftIcon && React.createElement(LeftIcon, { color: "primary", style: { margin: "auto" /* for centering */ }, size: 12 }),
            isTitleOverflowing ? (React.createElement(DataTableHeader_styled_1.TitleContainer, { onMouseEnter: isString_1.default(title) ? open(title) : noop_1.default, onMouseLeave: close, ref: $title }, title)) : (React.createElement(DataTableHeader_styled_1.TitleContainer, { ref: $title }, title)),
            React.createElement(DataTableHeader_styled_1.GhostTitleContainer, { hasIcon: Boolean(LeftIcon), ref: $ghostTitle }, title),
            RightIcon ? React.createElement(RightIcon, { color: "primary", style: { margin: "auto" /* for centering */ }, size: 12 }) : React.createElement("div", null),
            actions && (React.createElement(DataTableHeader_styled_1.ActionsContainer, null,
                React.createElement(ContextMenu_1.default, { items: actions },
                    React.createElement(Icon_1.ChevronDownIcon, { color: "color.text.lighter", size: 20, onClick: noop_1.default }))))),
        viewMorePopup &&
            react_dom_1.createPortal(React.createElement(DataTable_styled_1.ViewMorePopup, { top: viewMorePopup.y, left: viewMorePopup.x }, viewMorePopup.content), document.body)));
};
exports.default = DataTableHeader;
//# sourceMappingURL=DataTableHeader.js.map